/**
 * Spin button component - the center button that triggers the spin
 */

import React from 'react';
import type { SpinnerWheelSpinButtonProps } from '../types/wheel';
import './SpinnerWheelSpinButton.css';

export const SpinnerWheelSpinButton: React.FC<SpinnerWheelSpinButtonProps> = ({
  disabled = false,
  onClick,
  className = '',
}) => {
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <button
      className={`spinner-wheel-spin-button ${className}`}
      type="button"
      disabled={disabled}
      onClick={handleClick}
    >
      <svg
        className="play-icon"
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M19.669 10.385L6.199 2.257c-1.094-.66-2.77-.02-2.77 1.613v16.253c0 1.465 1.557 2.348 2.77 1.613l13.47-8.124c1.201-.723 1.205-2.504 0-3.227z"
          fill="white"
        />
      </svg>
    </button>
  );
};

export default SpinnerWheelSpinButton;
